/*
  Project: Vivafloors
  Author: Thomas
 */

/* eslint-disable */

const goBack = document.querySelectorAll('.js-go-back');

for (var i = 0; i < goBack.length; i++) {
  if(document.referrer.indexOf('vivafloors') > -1) {
    goBack[i].classList.remove('d-none');
    goBack[i].classList.add('d-block');
    goBack[i].onclick = function () {
      history.back();

      if (typeof gtag === 'function') {
        gtag('event', 'click', {
          'event_category': 'history',
          'event_label': 'back'
        });
      }
    }
  }
}

jQuery(document).ready(function() {
  const hash = window.location.hash;

  if (hash) {
    jQuery('.' + hash.replace('#', '')).click();
  }
});



// WEBPACK FOOTER //
// ./src/scripts/modules/history.js